export const USER_INPUT_DATE_FORMAT = 'dd.MM.yyyy'
export const BACKEND_DATE_FORMAT = 'yyyy-MM-dd'

export const CURRENCY_NAME = 'CHF'
export const COUNTRY_CODE = 'CH'

export const INVITATION_TOKEN_NAME = 'invitation-token'
